@if (animationState) {
  <div
    class="__animation-wrap"
    [style.--zef-fade-enter-duration]="enterDuration"
    [style.--zef-fade-leave-duration]="leaveDuration"
    [style.--zef-fade-easing]="easing"
    animate.enter="is-entering"
    animate.leave="is-leaving">
    <ng-content></ng-content>
  </div>
}
